<template>
  <section class="about-section" id="about">
    <div class="container">
      <!-- Main Header with animated reveal -->
      <div class="section-header" data-aos="fade-up" data-aos-duration="800">
        <h5 class="pre-title">Welcome to</h5>
        <h1 class="section-title">Your Cars LLC</h1>
        <div class="title-underline"></div>
        <p class="section-tagline">
          Your Cars LLC is your trusted partner in finding the car of your
          dreams! With a wide selection of quality vehicles, we ensure a
          seamless car-buying experience. Our professional and friendly team is
          here to assist you every step of the way.
        </p>
      </div>

      <!-- Core Services with hover effects -->
      <div
        class="services-container"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="100"
      >
        <div class="service-card">
          <div class="service-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path
                d="M14 16H9m10 0h3v-3.15a1 1 0 0 0-.84-.99L16 11l-2.7-3.6a1 1 0 0 0-.8-.4H5.24a2 2 0 0 0-1.8 1.1l-.8 1.63A6 6 0 0 0 2 12.42V16h2"
              ></path>
              <circle cx="6.5" cy="16.5" r="2.5"></circle>
              <circle cx="16.5" cy="16.5" r="2.5"></circle>
            </svg>
          </div>
          <h3>Online Car Exploration</h3>
          <p>
            Discover a curated selection of vehicles online, tailored to your
            preferences and budget.
          </p>
        </div>

        <div class="service-card">
          <div class="service-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <rect width="20" height="14" x="2" y="3" rx="2"></rect>
              <line x1="2" x2="22" y1="9" y2="9"></line>
              <path d="M7 15h.01"></path>
              <path d="M11 15h2"></path>
            </svg>
          </div>
          <h3>Smart Financing Tools</h3>
          <p>
            Estimate your budget and secure personalized financing rates with no
            impact on your credit score. We accept payments in cash, debit, and
            credit cards.
          </p>
        </div>

        <div class="service-card">
          <div class="service-icon">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            >
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10"></path>
              <path d="m9 12 2 2 4-4"></path>
            </svg>
          </div>
          <h3>Hassle-Free Process</h3>
          <p>
            Enjoy a transparent experience with clear pricing and expert support
            to guide you every step.
          </p>
        </div>
      </div>

      <!-- Company Overview with parallax scrolling effect -->
      <div
        class="about-content"
        data-aos="fade-up"
        data-aos-duration="1000"
        data-aos-delay="200"
      >
        <div class="about-image-container">
          <div class="about-image-wrapper">
            <div class="about-image"></div>
            <div class="image-accent"></div>
          </div>
        </div>

        <div class="about-text">
          <h2>About Our Company</h2>
          <p>
            At our dealership, we pride ourselves on providing exceptional
            service and a wide selection of vehicles to meet your needs. Our
            team is dedicated to helping you find the perfect car that fits your
            lifestyle and budget.
          </p>
        </div>
      </div>

      <!-- Call to Action with animated button -->
      <div
        class="cta-container"
        data-aos="fade-up"
        data-aos-duration="800"
        data-aos-delay="300"
        id="contact"
      >
        <h2>Join Our Family Today</h2>
        <p>
          Experience the difference with our personalized service and expert
          guidance. Contact us at +1 (424) 333-4220 to learn more about our
          offerings and schedule a visit!
        </p>
        <a href="tel:+14243334220" class="cta-button">
          <span>Get Started Now</span>
          <span class="button-icon">→</span>
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import AOS from "aos";
import "aos/dist/aos.css";

export default {
  name: "AboutSection",
  mounted() {
    AOS.init({
      once: true,
      offset: 50,
    });
  },
};
</script>

<style lang="scss" scoped>
.about-section {
  position: relative;
  padding: 120px 0;
  overflow: hidden;
  color: #1a1a2e;

  // Background design elements
  .background-design {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
    overflow: hidden;

    .circle {
      position: absolute;
      border-radius: 50%;
      opacity: 0.1;

      &.circle-1 {
        top: -100px;
        right: -100px;
        width: 400px;
        height: 400px;
        background: linear-gradient(45deg, #ff7043, #ee800a);
      }

      &.circle-2 {
        bottom: -150px;
        left: -150px;
        width: 500px;
        height: 500px;
        background: linear-gradient(45deg, #09283f, #16456b);
      }
    }

    .line {
      position: absolute;
      height: 2px;
      background: linear-gradient(
        90deg,
        transparent,
        rgba(238, 128, 10, 0.2),
        transparent
      );

      &.line-1 {
        top: 30%;
        left: 0;
        width: 100%;
        transform: translateY(-50%) rotate(-2deg);
      }

      &.line-2 {
        bottom: 25%;
        left: 0;
        width: 100%;
        transform: translateY(50%) rotate(1deg);
      }
    }
  }

  .container {
    width: 100%;
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 2rem;
    position: relative;
    z-index: 1;
  }

  // Header Section
  .section-header {
    text-align: center;
    margin-bottom: 4rem;

    .pre-title {
      text-transform: uppercase;
      letter-spacing: 3px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #ee800a;
      margin-bottom: 1rem;
    }

    .section-title {
      font-size: 3.5rem;
      font-weight: 700;
      margin-bottom: 1rem;
      color: #09283f;
      letter-spacing: -0.5px;
      line-height: 1.1;

      @media (max-width: 768px) {
        font-size: 2.5rem;
      }
    }

    .title-underline {
      width: 80px;
      height: 3px;
      background: linear-gradient(to right, #ee800a, #ff7043);
      margin: 0 auto 1.5rem;
      border-radius: 2px;
    }

    .section-tagline {
      font-size: 1.3rem;
      font-weight: 300;
      line-height: 1.6;
      max-width: 700px;
      margin: 0 auto;
      color: #4a4a4a;

      @media (max-width: 768px) {
        font-size: 1.1rem;
      }
    }
  }

  // Services Section
  .services-container {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 2rem;
    margin-bottom: 5rem;

    @media (max-width: 992px) {
      grid-template-columns: repeat(2, 1fr);
    }

    @media (max-width: 576px) {
      grid-template-columns: 1fr;
    }

    .service-card {
      background: white;
      border-radius: 10px;
      padding: 2.5rem 2rem;
      transition: all 0.4s ease;
      position: relative;
      overflow: hidden;
      box-shadow: 0 10px 30px rgba(0, 0, 0, 0.04);
      z-index: 1;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        height: 3px;
        background: linear-gradient(90deg, #ee800a, #ff7043);
        z-index: 2;
      }

      &:after {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: linear-gradient(
          135deg,
          rgba(238, 128, 10, 0.05) 0%,
          rgba(9, 40, 63, 0.03) 100%
        );
        z-index: -1;
        opacity: 0;
        transition: opacity 0.4s ease;
      }

      &:hover {
        transform: translateY(-10px);
        box-shadow: 0 20px 40px rgba(0, 0, 0, 0.08);

        &:after {
          opacity: 1;
        }

        .service-icon {
          color: #ee800a;
          transform: scale(1.1);
        }
      }

      .service-icon {
        width: 60px;
        height: 60px;
        display: flex;
        align-items: center;
        justify-content: center;
        margin-bottom: 1.5rem;
        color: #09283f;
        transition: all 0.4s ease;

        svg {
          width: 100%;
          height: 100%;
        }
      }

      h3 {
        font-size: 1.4rem;
        font-weight: 600;
        margin-bottom: 1rem;
        color: #09283f;
      }

      p {
        color: #555;
        line-height: 1.6;
        font-weight: 300;
        margin: 0;
      }
    }
  }

  // About Content Section with Image
  .about-content {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 4rem;
    margin-bottom: 5rem;
    align-items: center;

    @media (max-width: 992px) {
      grid-template-columns: 1fr;
      gap: 3rem;
    }

    .about-image-container {
      position: relative;

      .about-image-wrapper {
        position: relative;
        padding-bottom: 110%;

        .about-image {
          position: absolute;
          top: 0;
          left: 0;
          width: 90%;
          height: 90%;
          background-image: url("@/assets/Home/1.jpg");
          background-size: cover;
          background-position: center;
          border-radius: 10px;
          box-shadow: 0 20px 40px rgba(0, 0, 0, 0.1);
        }

        .image-accent {
          position: absolute;
          bottom: 0;
          right: 0;
          width: 65%;
          height: 65%;
          background: linear-gradient(135deg, #ee800a, #ff7043);
          border-radius: 10px;
          z-index: -1;
        }
      }
    }

    .about-text {
      h2 {
        font-size: 2.2rem;
        font-weight: 600;
        margin-bottom: 1.5rem;
        color: #09283f;
        position: relative;
        padding-bottom: 1rem;

        &:after {
          content: "";
          position: absolute;
          bottom: 0;
          left: 0;
          width: 60px;
          height: 3px;
          background: linear-gradient(to right, #ee800a, #ff7043);
          border-radius: 2px;
        }
      }

      p {
        margin-bottom: 1.5rem;
        line-height: 1.7;
        color: #4a4a4a;
        font-size: 1.05rem;
      }
    }
  }

  // Call to Action Section
  .cta-container {
    text-align: center;
    max-width: 700px;
    margin: 0 auto;
    padding: 3rem;
    background: white;
    border-radius: 10px;
    box-shadow: 0 20px 40px rgba(0, 0, 0, 0.06);
    position: relative;
    overflow: hidden;

    &:before {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 4px;
      background: linear-gradient(90deg, #09283f, #ee800a);
    }

    h2 {
      font-size: 2rem;
      font-weight: 600;
      margin-bottom: 1rem;
      color: #09283f;

      @media (max-width: 768px) {
        font-size: 1.6rem;
      }
    }

    p {
      color: #4a4a4a;
      margin-bottom: 2rem;
      line-height: 1.6;
      font-weight: 300;
    }

    .cta-button {
      display: inline-flex;
      align-items: center;
      justify-content: center;
      padding: 1rem 2.5rem;
      font-size: 1rem;
      font-weight: 500;
      color: #fff;
      background: linear-gradient(135deg, #ee800a, #ff7043);
      border: none;
      border-radius: 30px;
      cursor: pointer;
      transition: all 0.3s ease;
      text-decoration: none;
      text-transform: uppercase;
      letter-spacing: 1px;
      box-shadow: 0 10px 20px rgba(238, 128, 10, 0.2);
      position: relative;
      overflow: hidden;
      z-index: 1;

      &:before {
        content: "";
        position: absolute;
        top: 0;
        left: 0;
        width: 0;
        height: 100%;
        background: linear-gradient(135deg, #09283f, #16456b);
        z-index: -1;
        transition: width 0.4s ease;
      }

      &:hover {
        box-shadow: 0 10px 25px rgba(9, 40, 63, 0.3);

        &:before {
          width: 100%;
        }

        .button-icon {
          transform: translateX(5px);
        }
      }

      .button-icon {
        margin-left: 10px;
        transition: transform 0.3s ease;
      }
    }
  }
}
</style>
